var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManagementIconAdv5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 41,
    viewBox: "0 0 46 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 18.2747V18.1969L6.92456 18.1778C3.01843 17.1882 0.1 13.7688 0.1 9.707C0.1 4.88257 4.19818 0.918115 9.2 0.918115C14.2018 0.918115 18.3 4.88257 18.3 9.707C18.3 13.7688 15.3816 17.1882 11.4754 18.1778L11.4 18.1969V18.2747V27.4848V27.5848H11.5H16V31.8292H11.5H11.4V31.9292V36.3737V36.4737H11.5H18.3V40.7181H7V18.2747ZM27.6 9.607H27.5V9.707V14.1514V14.2514H27.6H41.4H41.5V14.1514V9.707V9.607H41.4H27.6ZM27.6 27.3848H27.5V27.4848V31.9292V32.0292H27.6H41.4H41.5V31.9292V27.4848V27.3848H41.4H27.6ZM13.9 9.707C13.9 7.16764 11.8197 5.16256 9.2 5.16256C6.58029 5.16256 4.5 7.16764 4.5 9.707C4.5 12.2464 6.58029 14.2514 9.2 14.2514C11.8197 14.2514 13.9 12.2464 13.9 9.707ZM23.1 7.48478V5.36256H45.9V18.4959H23.1V7.48478ZM23.1 25.2626V23.1403H45.9V36.2737H23.1V25.2626Z",
    fill: "#646AFF",
    stroke: "#F5F5F5",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagementIconAdv5);
export default __webpack_public_path__ + "static/media/management-icon-adv-5.b2207089c142878a505565c9e3c13df1.svg";
export { ForwardRef as ReactComponent };